import React from 'react';
import { useSelector } from 'react-redux';
import Icon, { SvgSrc } from '~/components/shared/Icon/Icon';
import Logo from '~/components/shared/LogoOld/LogoOld';
import MainMenu from '~/components/shared/Menu/MainMenu';
import ProgressStepperDots from '~/components/shared/ProgressStepperDots/ProgressStepperDots';
import { RootState } from '~/store/types/sharedTypes';
import { ComponentSize } from '~/styles/BaseStyledComponents';
import { theme } from '~/styles/themes';
import {
  BackButton,
  CenterGroup,
  OnboardingNavbarContainer,
  LeftGroup,
  RightGroup,
} from './OnboardingNavbar.styled';

interface OnboardingNavbarProps {
  absolutePosition?: boolean;
  fixedPosition?: boolean;
  showBackButton?: boolean;
  onBackClick?: () => void;
  progressStepperDots?: {
    steps: any;
    currentStep: number;
  };
  filledBackground?: boolean;
  showLogo?: boolean;
}

const OnboardingNavbar = ({
  absolutePosition,
  fixedPosition,
  filledBackground,
  showLogo,
  showBackButton,
  onBackClick,
  progressStepperDots,
}: OnboardingNavbarProps) => {
  const { matchedMedia } = useSelector((state: RootState) => state);

  return (
    <OnboardingNavbarContainer
      absolutePosition={absolutePosition}
      fixedPosition={fixedPosition}
      filledBackground={filledBackground}
    >
      <LeftGroup>
        {showLogo && (
          <Logo
            // onClick={() => {
            //   window.location.assign(getHomePageByMarket(market, language));
            // }}
            noLink
            size={
              matchedMedia.desktop
                ? ComponentSize.Medium
                : ComponentSize.MenuIcon
            }
          />
        )}

        {showBackButton && onBackClick && (
          <BackButton data-cy="navbar_back_button" onClick={onBackClick}>
            <Icon
              color={theme.colors.secondaryBlack}
              src={SvgSrc.ChevronLeft}
              size={ComponentSize.Medium}
            />
          </BackButton>
        )}
      </LeftGroup>
      <CenterGroup>
        {progressStepperDots && (
          <ProgressStepperDots
            steps={progressStepperDots.steps}
            currentStep={progressStepperDots.currentStep}
          />
        )}
      </CenterGroup>
      <RightGroup>
        <MainMenu />
      </RightGroup>
    </OnboardingNavbarContainer>
  );
};

export default OnboardingNavbar;
